import type { ProjectConfig } from '../project'

export const makerspaceConfig: ProjectConfig = {
  id: 'makerspace',
  name: 'Makerspace Carinthia',

  api: {
    artrackUrl: 'https://api-artrack.arkturian.com',
    storageUrl: 'https://api-storage.arkturian.com',
    apiKey: 'Inetpass1',
    trackId: 24,
  },

  map: {
    type: 'blank',
    center: { lat: 46.624, lng: 14.305 },
    defaultZoom: 6,
    backgroundColor: '#1a1a2e',
  },

  pins: {
    defaultStyle: 'dot',
    categoryIcons: {
      poi: '📍', workspace: '🔧', office: '🏢', meeting: '👥',
      tech: '💻', workshop: '🛠️', amenity: '☕',
    },
  },

  theme: {
    primary: '#FF6B35',
    background: '#1a1a2e',
    text: '#E0E0E0',
    fontHeading: "'Space Grotesk', system-ui, sans-serif",
    fontBody: "'Inter', system-ui, sans-serif",
  },

  features: {
    audioGuide: true,
    stories: false,
    kioskMode: false,
    species: false,
    navigation: true,
    routeIntelligence: false,
    threeD: false,
  },

  defaultRouteId: 25,
  routeIds: [25, 64],
}
